import { MarketingNav } from './MarketingNav';
import { MarketingFooter } from './MarketingFooter';
import { useLocation } from 'react-router-dom';
import './marketing-editorial.css';

interface MarketingLayoutProps {
  children: React.ReactNode;
}

export function MarketingLayout({ children }: MarketingLayoutProps) {
  const { pathname } = useLocation();
  const isSubpage = pathname !== '/';

  return (
    <div className="marketing-shell min-h-screen overflow-x-clip selection:bg-[#8DA696]/45">
      <a className="marketing-skip-link" href="#marketing-main">Skip to content</a>
      <MarketingNav />
      <main id="marketing-main" tabIndex={-1} className={isSubpage ? 'marketing-subpage' : undefined}>{children}</main>
      <MarketingFooter />
    </div>
  );
}
